import React from 'react';
import { FaExchangeAlt } from 'react-icons/fa';

export function TransferOwnershipModal({ 
  show, 
  members, 
  currentUser, 
  transferToUserId, 
  setTransferToUserId, 
  transferring, 
  onTransfer, 
  onClose 
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="transfer-ownership-modal">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-3 bg-amber-100 rounded-full">
            <FaExchangeAlt className="text-amber-600 text-xl" />
          </div>
          <h3 className="text-2xl font-bold text-gray-800">Transfer Ownership</h3>
        </div>
        
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
          <p className="text-amber-800 text-sm">
            <strong>Warning:</strong> Transferring ownership will give another member full control over this family. 
            You will lose all owner privileges, including the ability to archive, delete, or transfer the family.
          </p>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">Transfer to:</label>
          <select
            value={transferToUserId}
            onChange={(e) => setTransferToUserId(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-600 focus:border-transparent"
            data-testid="transfer-to-select"
          >
            <option value="">Select a member...</option>
            {members
              .filter(m => m.user_id !== currentUser?.user_id)
              .map(member => (
                <option key={member.user_id} value={member.user_id}>
                  {member.name} ({member.email})
                </option>
              ))
            }
          </select>
        </div>

        <div className="flex space-x-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onTransfer}
            disabled={transferring || !transferToUserId}
            className="flex-1 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 disabled:opacity-50"
            data-testid="confirm-transfer-btn"
          >
            {transferring ? 'Transferring...' : 'Transfer Ownership'}
          </button>
        </div>
      </div>
    </div>
  );
}
